import { Injectable } from "@angular/core";
import { Http, Response, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';

import { environment } from './../../environments/environment';

import { Configurations } from "../core/configurations";
import { IncassoModel } from './../models/incassi/incasso.model';
import { IncassoAssegniListItemModel } from "../models/incassi/incasso-assegni-list-item.model";
import { IncassoContantiListItemModel } from "../models/incassi/incasso-contanti-list-item.model";
import { DizionarioModel } from './../models/shared/dizionario.model';
import { PagedListModel } from "../models/shared/paged-list.model";
import { guid, newId } from '../core/utilities';
import { LocalDb } from '../core/localdb';
import {BancheItemsModel} from "../models/brogliacci/banche.model";

import {AuthService} from "./auth.service";
import { ContantiIncassiCreateCommand } from "../models/incassi/contanti-incassi-create-command";

@Injectable()
export class IncassiDettaglioService {
  APIIncassiDettaglio = this.configuration.apiBaseUrlIncassiDettaglio;
  APITipiAssegni = this.configuration.apiBaseUrlTipiAssegni;
  MethodModificaContanti= "modificaContanti";
  MethodModificaAssegni= "modificaAssegni";
  MethodInserisciContanti="inserisciContanti";
  MethodInserisciAssegni="inserisciAssegni";
  MethodVerificaAssegno="verificaAssegno";
  MethodGetAssegni="listaAssegni";
  MethodGetContanti="listaContanti";
  MethodUpload = "upload";
  MethodDownload = "download";
  MethodBanche= "dettaglioBanca";
 
  constructor(private http: Http, private configuration: Configurations, private authenticationService:AuthService) {
  }
  insertContanti(model: IncassoContantiListItemModel[], tokenIncasso: string): Observable<ContantiIncassiCreateCommand> {
    let url = this.APIIncassiDettaglio;
    for(let incDet of model){
      if(incDet.token==="") {
        incDet.token=null;
        if(incDet.quantita!==undefined&&incDet.quantita!=null) {
          incDet.quantita=parseInt(((incDet.quantita+""==="")?"0":incDet.quantita+""),10);
        } else {
          incDet.quantita=0;
        }
      }
    }
    return this.http.post(url+this.MethodInserisciContanti+"/"+tokenIncasso, model).map(res => res.json())
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });
  }
  insertAssegni(model: IncassoAssegniListItemModel, tokenIncasso: string): Observable<IncassoAssegniListItemModel> {
    let url = this.APIIncassiDettaglio;
    model.nomeBanca=model.nomeBanca;
    return this.http.post(url+this.MethodInserisciAssegni+"/"+tokenIncasso, model).map(res => res.json())
    .catch((error: any) => Observable.throw(error));
    
  }
  updateContanti(model: IncassoContantiListItemModel[]): Observable<IncassoContantiListItemModel> {
    let url = this.APIIncassiDettaglio;
    return this.http.put(url+this.MethodModificaContanti, model).map(res => res.json())
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });
   
  }

  //al momento non usato
  updateAssegni(model: IncassoAssegniListItemModel): Observable<IncassoAssegniListItemModel> {
    let url = this.APIIncassiDettaglio;
    return this.http.put(url+this.MethodModificaAssegni, model).map(res => res.json())
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });

    
  }
  //elimina tutti i dettagli dell'incasso
  delete(model:IncassoModel):Observable<Response> {
    let url = this.APIIncassiDettaglio;
    return this.http.delete(url+model.tokenIncasso).map(res => {
      return res.json();
    })
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    })
    ;
  }
  deleteDettaglio(token:string):Observable<Response> {
    let url = this.APIIncassiDettaglio;
    return this.http.delete(url+token).map(res => { 
      return res.json();
    })
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    })
    ;
  }

  verificaAssegno(tokenAssegno: string): Observable<Response> {
    let url = this.APIIncassiDettaglio+this.MethodVerificaAssegno+"/"+tokenAssegno;
    return this.http.post(url, null).map(res => { 
      return res.json(); })
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });

  }

  
  getAssegni(tokenIncasso: string): Observable<IncassoAssegniListItemModel[]> {
    
    let url = this.APIIncassiDettaglio + this.MethodGetAssegni;
    return this.http.get(url + '/' + tokenIncasso)
      .map((r: Response) => r.json() as IncassoModel)
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });

  }

  getContanti(tokenIncasso: string): Observable<IncassoContantiListItemModel[]> {
    
    let url = this.APIIncassiDettaglio + this.MethodGetContanti;
    return this.http.get(url + '/' + tokenIncasso)
      .map((r: Response) => r.json() as IncassoModel)
      .catch((r:any)=> {        
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });

  }

  getFileImage(token: string, fronteretro: string): Observable<Blob> {
    let url = this.APIIncassiDettaglio + this.MethodDownload + "/" + token+ "/" + fronteretro;
    return this.http
      .get(url, { responseType: ResponseContentType.Blob })
      .map((res: Response) => res.blob())
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }


  uploadImmagineAssegno(formData: FormData): Observable<Response> {
    
        let url = this.APIIncassiDettaglio + this.MethodUpload;
        return this.http.post(url, formData)
          .map(res => { return res.json(); 
          })
          .catch((r:any)=> {
            if(r.status===401) {
              this.authenticationService.logoutIfSessionExpired().subscribe(
                (res:any)=> {
      
                });
              return Observable.throw("Autorizzazione negata.");
            }
            Observable.throw(r.json().error || 'Server error');
          });
      }


  getBancaByAbiCab(abiR: number, cabR: number): Observable<BancheItemsModel> {
    
        let url = this.APIIncassiDettaglio+this.MethodBanche+ "/"+abiR+"/"+cabR;
        return this.http.get(url)
          .map((r: Response) => r.json() as DizionarioModel[])
          .catch((r:any)=> {
            if(r.status===401) {
              this.authenticationService.logoutIfSessionExpired().subscribe(
                (res:any)=> {
      
                });
              return Observable.throw("Autorizzazione negata.");
            }
            Observable.throw(r.json().error || 'Server error');
          });
    
      }
    
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/incassi-dettaglio.service.ts